import React, { useMemo } from 'react';
import { formatCurrency } from 'utils';
import { Box, Typography } from '@mui/material';
import { blue, blueGrey } from '@mui/material/colors';
import { Column } from 'components/shared/TableListing/types';

import { quoteChargeCalculator } from '../../../../lib';
import {
  QuoteChargeCalcRow,
  QuoteChargeCalcResult,
  QuoteChargeColumnTotals,
  QuoteChargeListingContext,
  QuoteChargeListingEntity,
} from '../../../../types';

interface Props {
  data: QuoteChargeListingEntity[];
  priceCalc: QuoteChargeCalcResult;
  columns: Column<QuoteChargeListingEntity, QuoteChargeListingContext>[];
}

export const GroupSubtotalRow = ({ data, columns, priceCalc }: Props) => {
  const subtotal = useMemo<QuoteChargeColumnTotals>(() => {
    const byKey = new Map<string, QuoteChargeCalcRow>();

    priceCalc.rows.forEach(row => {
      const key = quoteChargeCalculator.rowKey(row);

      if (key) byKey.set(key, row);
    });

    const groupRows = data
      .map(entity => {
        const key = quoteChargeCalculator.rowKey(entity);

        return key ? byKey.get(key) : undefined;
      })
      .filter((row): row is QuoteChargeCalcRow => Boolean(row));

    return quoteChargeCalculator.columnTotals(groupRows);
  }, [data, priceCalc]);

  return (
    <Box className="listing-section">
      {columns.map((column, index) => (
        <Box
          key={`${column.renderKey}_${index}`}
          className="listing-cell"
          style={{ minHeight: 'auto', padding: '0.5rem 1rem' }}
          sx={{ backgroundColor: blue[50], color: blueGrey[800], fontWeight: 600 }}
        >
          {column.renderKey === 'type' ? (
            <Typography variant="subtitle2" component="span">
              Subtotal
            </Typography>
          ) : (
            column.renderKey && (
              <Typography variant="subtitle2">
                {formatCurrency(subtotal[column.renderKey as keyof QuoteChargeColumnTotals] ?? null, true)}
              </Typography>
            )
          )}
        </Box>
      ))}
    </Box>
  );
};
